<template>
  <div>
    <b-card header-tag="header" class="m-0 m-lg-2" no-body>
      <template #header>
        <HeaderSagres class="avaliacoes-gerais-header" titulo="Avaliações Gerais" :botoes="botoesHeader">
          <template #customContent>
          </template>
        </HeaderSagres>
      </template>
      <b-card-body class="p-0">
        <card-filtros-busca>
          <b-form @submit.prevent="loadData" @reset.prevent="limparFiltros">
            <b-row>
              <b-col cols="6" lg="3">
                <b-form-group id="input-group-ano" label-size="md" label="Ano">
                  <b-form-input v-model="filtros.ano"></b-form-input>
                </b-form-group>
              </b-col>
              <b-col cols="6" lg="2" class="pt-4">
                <b-button type="reset" variant="outline-secondary">
                  <font-awesome-icon icon="redo" class="mr-3" />Limpar
                </b-button>
              </b-col>
              <b-col cols="6" lg="2" class="pt-4">
                <b-button type="submit" :disabled="loadingAvaliacoes">
                  <font-awesome-icon icon="search" class="mr-3" />Filtrar
                </b-button>
              </b-col>
            </b-row>
          </b-form>
        </card-filtros-busca>

        <b-table class="serigy-avaliacoes-table" :fields="fields" :items="listaAvaliacoes" :busy="loadingAvaliacoes"
          hover no-border-collapse sort-by="" :sort-desc="true" striped stacked="lg" responsive
          show-empty>
          <template #empty>
            <span>Não foram encontrados dados.</span>
          </template>
          <template #emptyfiltered>
            <span>Não foram encontrados dados.</span>
          </template>
          <template #table-busy>
            <div class="text-center text-dark">
              <b-spinner class="align-middle"></b-spinner>
              <strong class="loading-text">Carregando...</strong>
            </div>
          </template>
          <!-- TODO: Isso é copiado de DetalhesLotesItens.vue, e deve haver outros por aí. Dá pra centralizar o visual num componente passando as variáveis por prop/emit, e tbm dá pra centralizar o table-field usado -->
          <template v-slot:cell(avaliacoes)="row">
            <b-link class="text-dark" @click="row.toggleDetails">
              <font-awesome-icon :icon="row.detailsShowing ? 'chevron-up' : 'chevron-down'" />
            </b-link>
          </template>
          <template v-slot:cell(publico)="row">
            <font-awesome-icon :icon="row.item.publico ? 'check' : 'xmark'" />
          </template>
          <template #row-details="row">
            <TabelaAvaliacoes :avaliacaoGeral="row.item" />
          </template>
          <template v-slot:cell(actions)="row">
            <div class="actions-icons">
              <b-link class="text-dark serigy-action-link" @click="alertaReavaliarAvaliacaoGeral(row.item)">
                <font-awesome-icon icon="redo" />
                <div class="serigy-action-label">Reavaliar</div>
              </b-link>
              <b-link class="text-dark serigy-action-link" @click="alertaTogglePublico(row.item)">
                <font-awesome-icon :icon="row.item.publico ? 'eye-slash' : 'eye'" />
                <div class="serigy-action-label">{{ row.item.publico ? 'Despublicar' : 'Publicar' }}</div>
              </b-link>
            </div>
          </template>
        </b-table>
      </b-card-body>
    </b-card>
    <modal-add-avaliacao-geral v-if="exibirModalNovaAvaliacao" @fecharModal="toggleModalNovaAvaliacao"
      @novaAvaliacao="onNovaAvaliacao" />
  </div>
</template>

<script lang="ts">
import { UtilsTS } from "@/utilsts";
import { mixins } from "vue-class-component";
import { Component, Vue } from "vue-property-decorator";
import serigyService from "@/services/administracao/serigyService";
import HeaderSagres from "@/components/shared/HeaderSagres.vue";
import { AvaliacaoGeral } from "@/types/administracao/serigy/avaliacao-geral/avaliacao-geral";
import { fieldsAvaliacoesGerais } from "@/types/administracao/serigy/avaliacao-geral/fields-avaliacoes-gerais";
import { TableField } from "@/types/table-field";
import TabelaAvaliacoes from "@/components/serigy/TabelaAvaliacoes.vue";
import ModalAddAvaliacaoGeral from "@/components/serigy/ModalAddAvaliacaoGeral.vue";
import { BotaoSagres } from "@/types/botao-sagres";
import CardFiltrosBusca from '@/components/shared/CardFiltrosBusca.vue';

const CompProps = Vue.extend({
  name: "Invoker",
  components: {
    ModalAddAvaliacaoGeral,
    HeaderSagres,
    CardFiltrosBusca,
    TabelaAvaliacoes,
  },
});

@Component
export default class AvaliacaoGeralComponent extends mixins(UtilsTS, CompProps) {
  fields: TableField[] = fieldsAvaliacoesGerais;
  listaAvaliacoes: AvaliacaoGeral[] = [];
  loadingAvaliacoes = false;
  exibirModalNovaAvaliacao = false;
  botoesHeader: BotaoSagres[] = [
    {
      id: 1,
      icone: 'plus',
      texto: 'Nova Avaliação Geral',
      acao: this.toggleModalNovaAvaliacao,
    },
  ]
  filtros = {
    ano: new Date().getFullYear()
  }

  async loadData(): Promise<void> {
    try {
      this.loadingAvaliacoes = true;
      const avaliacoes = await serigyService.listarAvaliacoesGeraisPorAno(this.filtros.ano) as unknown as AvaliacaoGeral[];
      this.listaAvaliacoes = avaliacoes;
    } catch (error) {
      this.tratarError(error);
      this.listaAvaliacoes = [];
    } finally {
      this.loadingAvaliacoes = false;
    }
  }

  async reavaliarAvaliacaoGeral(avaliacaoGeral: AvaliacaoGeral): Promise<void> {
    try {
      await serigyService.reavaliarAvaliacaoGeral(avaliacaoGeral.id);
      await this.loadData();
    } catch (error) {
      this.tratarError(error);
    }
  }

  async togglePublico(avaliacaoGeral: AvaliacaoGeral): Promise<void> {
    try {
      await serigyService.togglePublicoAvaliacaoGeral(avaliacaoGeral.id);
      await this.loadData();
    } catch (error) {
      this.tratarError(error);
    }
  }

  async onNovaAvaliacao(novaAvaliacao: AvaliacaoGeral): Promise<void> {
    try {
      this.loadingAvaliacoes = true
      await this.loadData()
      this.toggleModalNovaAvaliacao()
    } finally {
      this.loadingAvaliacoes = false
    }
  }

  toggleModalNovaAvaliacao() {
    this.exibirModalNovaAvaliacao = !this.exibirModalNovaAvaliacao
  }

  limparFiltros(): void {
    this.filtros.ano = new Date().getFullYear()
  }

  alertaTogglePublico(avaliacaoGeral: AvaliacaoGeral): any {
    const title = avaliacaoGeral.publico ? 'Desublicar Avaliação Geral' : 'Publicar Avaliação Geral';
    const message = avaliacaoGeral.publico
      ? 'Deseja despublicar a avaliação geral? Ao confirmar, as avaliações desaparecerão do Painel do Observatório'
      : 'Deseja publicar a avaliação geral? Ao confirmar, as avaliações aparecerão no Painel do Observatório';

    this.$bvModal
      .msgBoxConfirm(
        message,
        {
          buttonSize: "sm",
          cancelTitle: "Cancelar",
          cancelVariant: "outline-secondary",
          centered: true,
          headerBgVariant: "secondary",
          headerTextVariant: "light",
          okTitle: "Confirmar",
          okVariant: "secondary",
          title: title,
        }
      )
      .then((value) => {
        if (value) {
          if (avaliacaoGeral.id) {
            this.togglePublico(avaliacaoGeral);
          }
        }
      })
      .catch((err) => {
        console.error(
          `Erro ao operar o dialog de publicação de avaliação geral`,
          err
        );
      });
  }

  alertaReavaliarAvaliacaoGeral(avaliacaoGeral: AvaliacaoGeral): any {
    this.$bvModal
      .msgBoxConfirm(
        `Deseja reavaliar a avaliação geral?`,
        {
          buttonSize: "sm",
          cancelTitle: "Cancelar",
          cancelVariant: "outline-secondary",
          centered: true,
          headerBgVariant: "secondary",
          headerTextVariant: "light",
          okTitle: "Confirmar",
          okVariant: "secondary",
          title: "Reavaliar Avaliação Geral",
        }
      )
      .then((value) => {
        if (value) {
          if (avaliacaoGeral.id) {
            this.reavaliarAvaliacaoGeral(avaliacaoGeral);
          }
        }
      })
      .catch((err) => {
        console.error(
          `Erro ao operar o dialog de reavaliação de avaliação geral`,
          err
        );
      });
  }

  mounted(): void {
    this.loadData();
  }
}
</script>
<style scoped>
span.sitBadge.success {
  color: #fff;
  background-color: #28a745;
}

span.sitBadge.warning {
  background-color: #ffc107;
}

span.sitBadge.danger {
  color: #fff;
  background-color: #dc3545;
}
</style>
